import { createApp } from "vue"
import App from "./views/App.vue"
import router from "./router"
import { createPinia } from "pinia"
import "ant-design-vue/dist/antd.variable.min.css"
import antd from "ant-design-vue"

const app = createApp(App)
app.config.errorHandler = (error) => {
  console.error(error)
}
app.use(createPinia()).use(antd).use(router).mount("#app")
